import Rails from "@rails/ujs"
import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['form','addButton'];
  static classes = ['errorm','hide'];
  static values = {uploadurl: String, removeimageurl: String, addimagefieldurl: String, maxFields: Number};

  formTargetConnected() {
    const index = document.getElementById("image_index");
    this.removeAddButton(Number(index.value));
  }

  // YAS-31: interview_add_image_field が「全フィールドの再描画」から「新規1フィールドのみ」に
  // 変わったことへの追随（患者の問診フォームと同一エンドポイントを共有しているため必須）。
  // 採番は送信前に同期的に済ませ、応答は innerHTML の置換ではなく末尾への追記にする。
  // なお管理画面は iOS 実機での利用を想定しないため、空body対策そのものの横展開は行わない。
  addUploadField(){
    const uploadField = document.getElementById("diagnostic_image_upload_field");
    const indexField = document.getElementById("image_index");
    if(uploadField == null || indexField == null){ return; }

    const nextIndex = Number(indexField.value) + 1;
    if(!Number.isFinite(nextIndex)){ return; }
    indexField.value = nextIndex;

    Rails.ajax({
      url: this.addimagefieldurlValue,
      type: "POST",
      dataType: 'html',
      // 文字列で渡すと form-urlencoded になり、写真バイナリを載せずに済む
      // YAS-34 でエンドポイントが患者用／管理用に分離されたため jsc は送らない
      // （描画に使う Stimulus 識別子はサーバ側の固定値）
      data: new URLSearchParams({index: nextIndex}).toString(),
      success: (response) => {
        if(response == null || response.body == null){ return; }
        uploadField.insertAdjacentHTML('beforeend', response.body.innerHTML);
      }
    });
    this.removeAddButton(nextIndex);
  }

  autoUpload(event){
    const el = event.currentTarget;
    const params = event.params;
    const targetName = params.targetname;
    const index = params.index;
    if(el.value != null && el.value != ""){
      const formData = new FormData(this.formTarget);
      formData.append("type",targetName);
      formData.append("index",index);
      Rails.ajax({
        url: this.uploadurlValue,
        type: "POST",
        dataType: 'json',
        data: formData,
        success: (response) => {
          if(response.error != null){
            document.getElementById("diagnostic_images_"+targetName+"_error_message").textContent = response.error;
          }else {
            const viewDiv = document.getElementById("image_view_" + targetName);
            const image = viewDiv.querySelector("img");
            image.src = response.image_url;
            viewDiv.classList.remove(this.hideClass);
            document.getElementById("image_upload_" + targetName).classList.add(this.hideClass);
            document.getElementById("diagnostic_images_id_" + index).value = response.di_id;
            document.getElementById("diagnostic_images_" + targetName + "_error_message").textContent = "";
          }
        }
      });
    }
  }

  removeImage(event){
    const params = event.params;
    const targetName = params.targetname;
    const formData = new FormData(this.formTarget);
    const index = params.index;
    formData.append("type",targetName);
    formData.append("index",index);
    Rails.ajax({
      url: this.removeimageurlValue,
      type: "POST",
      dataType: 'json',
      data: formData,
      success: (response) => {
        console.log(response);
        const viewDiv = document.getElementById("image_view_"+targetName);
        const image = viewDiv.querySelector("img");
        image.src = "";
        viewDiv.classList.add(this.hideClass);
        document.getElementById("diagnostic_images_id_"+index).value = null;
        document.getElementById("image_upload_"+targetName).classList.remove(this.hideClass);
      }
    });
  }

  // YAS-33: 上限はサーバ定数（ReservationImageUpload::MAX_DIAGNOSTIC_IMAGE_FIELDS）を唯一の正とし、
  // ビューが max-fields-value として出力する。旧実装の `index >= 2` のハードコードは撤去した
  // （患者側 reservation_interview_controller#maxFieldCount と同型。定数変更だけで両画面が追随する）。
  maxFieldCount(){
    return (this.hasMaxFieldsValue && this.maxFieldsValue > 0) ? this.maxFieldsValue : 2;
  }

  removeAddButton(index){
    if(!this.hasAddButtonTarget){ return; }
    if(index >= this.maxFieldCount()){
      this.addButtonTarget.classList.add('is-hidden')
    }
  }
}
